import { AxiosResponse } from "axios";
import BaseService from "./BaseService";
import BeneficiarioNoAfiliado from "@/models/BeneficiarioNoAfiliado";
import ConsultaFallecido, {
  ConsultaValidacionFallecimientoAll,
  ConsultaValidacionBeneficiarioResp,
} from "@/models/ConsultaFallecido";
import ServiceResponse from "@/services/response-models/ServiceResponse";
import { DashboardResponse } from "@/models/Dashboard/DashboardResponse";
import { DashboardTrimestralResponse } from "@/models/Dashboard/DashboardTrimestralResponse";
import { BeneficiosDisponiblesResponse } from "@/models/Dashboard/BeneficiosDisponiblesResponse";
import { VideoIntroResponse } from "@/models/Dashboard/VideoIntroResponse";
import { PhotoBeneficiarioResponse } from "@/models/Dashboard/PhotoBeneficiarioResponse";
import ServiceResponseEntity from "./response-models/ServiceResponseEntity";
import ServiceResponseSolicitud from "./response-models/ServiceResponseSolicitud";
import ServiceResponseSolicitudes from "./response-models/ServiceResponseSolicitudes";
import ServiceResponseArchivos from "./response-models/ServiceResponseArchivos";
import ParametrosCatalogo from "@/models/ParametrosCatalogo";
import {
  AseguradoraCatalogoResponse,
  CatalogoResponse,
} from "@/models/CatalogoResponse";
import RegistroPresolicitud from "@/models/RegistroPresolicitud";
import RecuperacionClave from "@/models/RecuperacionClave";
import AfiliadoData from "@/models/AfiliadoData/AfiliadoData";
import CambioClave from "@/models/CambioClave";
import Banco from "@/models/Banco";
import FormaDePago from "@/models/FormaDePago";
import ServiceResponseEntities from "./response-models/ServiceResponseEntities";
import FirmanteContratoIngresoTardio from "@/models/FirmanteContratoIngresoTardio";
import PackageResult from "@/models/PackageResult";
import ParametrosObtencionPresolicitud from "@/models/ParametrosObtencionPresolicitud";
import ModalidadRetiroITResponse, {
  ModalidadRetiroIT,
} from "@/models/ModalidadRetiroIT/ModalidadRetiroIT";
import ParamsGetSolicitud from "@/models/ParamsGetSolicitud";
import SolicitudBeneficio from "@/models/SolicitudBeneficio";
import FormularioSobrevivencia from "@/models/RegistroSobrevivencia/FormularioSobrevivencia";
import ServiceResponseFormulario from "./response-models/ServiceResponseFormulario";
import DocumentosBeneficiariosRequest from "@/models/Sobrevivencia/Documentos/DocumentosBeneficiariosRequest";
import DocumentosBeneficiariosResponse from "@/models/Sobrevivencia/Documentos/DocumentosBeneficiariosResponse";
import BenefactorDocument from "@/models/Sobrevivencia/BenefactorDocument";
import ResponseCodeMessage from "@/models/Sobrevivencia/ResponseCodeMessage";
import Catalogo from "@/models/Sobrevivencia/GeneralDocument";
import GuardarDocumentos from "@/models/Sobrevivencia/GuardarDocumentos";
import Benefactor from "@/models/Sobrevivencia/Benefactor";
import DocumentoCatalogo from "@/models/Sobrevivencia/GeneralDocument";
import ResponseCodeMessageOnly from "@/models/Sobrevivencia/ResponseCodeMessageOnly";
import SaveBeneficiarioRequest from "@/models/Sobrevivencia/Formulario/SaveFormularioRequest";
import BaseSobrevivenciaResponse from "@/models/Sobrevivencia/BaseSobrevivenciaResponse"
import BaseSobrevivenciaRequest from "@/models/Sobrevivencia/BaseSobrevivenciaRequest";
import SobrevivenciaPresolicitudResponse from "@/models/Sobrevivencia/SobrevivenciaPresolicitud/SobrevivenciaPresolicitudResponse";
import EtapaRequest from "@/models/Sobrevivencia/SobrevivenciaPresolicitud/EtapaRequest";
import EliminarBeneficiarioRequest from "@/models/Sobrevivencia/Formulario/EliminarBeneficiario";
import UbigeoRequest from "@/models/Sobrevivencia/Formulario/UbigeoRequest";  import FirmaDescargoRequest from "@/models/Sobrevivencia/Firma/FirmaDescargoRequest";
import DistribucionBalance from "@/models/Sobrevivencia/DistribucionBalante/DistribucionBalance";
import DistribucionBalanceResponse from "@/models/Sobrevivencia/DistribucionBalante/DistribucionBalanceResponse";
import ReenvioBiometricaRequest from "@/models/Sobrevivencia/Biometric/ReenvioValidacionBiometricaRequest";
export default class SobrevivenciaService extends BaseService<any> {
  public constructor() {
    super("Sobrevivencia");
  }

  public async getSobrevivenciaForm(): Promise<
    AxiosResponse<FormularioSobrevivencia>
  > {
    let action: string = "getForm";

    return this.post(action, null);
  }

  public async getVideoIntro(
    userIdentity: string
  ): Promise<AxiosResponse<VideoIntroResponse>> {
    let action: string = "ObtenerVideoIntro";

    return this.post(action, { cedulaAfiliado: userIdentity });
  }
  public async VideoIntroPost(
    userIdentity: string
  ): Promise<AxiosResponse<VideoIntroResponse>> {
    let action: string = "VideoIntroPost";

    return this.post(action, {
      cedulaAfiliado: userIdentity,
      mostrarVideo: false,
    });
  }

  public async GetBeneficiarios(
    canal: string,
    codUsuario: string,
    numPreSolicitud: number
  ): Promise<AxiosResponse<ResponseCodeMessage<Benefactor[]>>> {
    return this.post("GetBeneficiarios", {
      canal,
      codUsuario,
      numPreSolicitud,
    });
  }

  public async SaveBeneficiarios(
    canal: string,
    codUsuario: string,
    data: Benefactor[]
  ): Promise<AxiosResponse<ResponseCodeMessageOnly>> {
    return this.post("saveBeneficiarios", {
      canal,
      codUsuario,
      data,
    });
  }

  public async GetCatalogo(
    canal: string,
    codUsuario: string
  ): Promise<
    AxiosResponse<ResponseCodeMessage<{ requisitos: DocumentoCatalogo[] }>>
  > {
    return this.post("GetCatalogo", {
      canal,
      codUsuario,
    });
  }

  public async GetDocumentosBeneficiarios(
    numPreSolicitud: number,
    canal: string,
    codUsuario: string,
    idBeneficiario?: number
  ): Promise<AxiosResponse<ResponseCodeMessage<BenefactorDocument[]>>> {
    return this.post("GetDocumentosBeneficiarios", {
      idBeneficiario,
      numPreSolicitud,
      canal,
      codUsuario,
    });
  }

  public async GuardarDocumentacion(
    canal: string,
    codUsuario: string,
    data: GuardarDocumentos[]
  ): Promise<AxiosResponse<ResponseCodeMessage<{ requisitos: Catalogo[] }>>> {
    return this.post("GuardarDocumentacion", {
      canal,
      codUsuario,
      data,
    });
  }

  public async GetPhotoBeneficiario(
    userIdentity: string
  ): Promise<AxiosResponse<PhotoBeneficiarioResponse>> {
    let action: string = "GetPhotoBeneficiario";

    return this.post(action, { userIdentity: userIdentity });
  }

  public async uploadDocumentation(
    registroPresolicitud: RegistroPresolicitud,
    documentos: { [key: string]: File[] }
  ): Promise<AxiosResponse<ServiceResponseEntity<string[]>>> {
    return this.post(
      "SubirDocumentacion",
      { registroPresolicitud },
      documentos
    );
  }
  public async getFormulario(
    isBeneficiarioForm: boolean = false,
    numSolicitud : number ,
    codUsuario: string = ""
  ): Promise<AxiosResponse<ServiceResponseFormulario>> { 
    console.log("---------------------"+ numSolicitud)
    if (isBeneficiarioForm) {
      return this.post("GetFormulario", {
        canal: "PortalBe",
        codUsuario: codUsuario,
        numPreSolicitud: numSolicitud,
        rootId: 562,
        numSecuencia: 2,
      });
    } else {
      return this.post("GetFormulario", {
        canal: "PortalBe",
        codUsuario: codUsuario,
        numPreSolicitud: numSolicitud,
        rootId: 1,
        numSecuencia: 1,
      });
    }
  }

  public async getDocumentosBeneficiarios(
    request: DocumentosBeneficiariosRequest
  ): Promise<AxiosResponse<DocumentosBeneficiariosResponse>> {
    return this.post("getDocumentosBeneficiarios", request);
  }

  public async saveFormulario(
    request: SaveBeneficiarioRequest
  ): Promise<AxiosResponse<BaseSobrevivenciaResponse>> {
    return this.post("SaveFormulario", request);
  }
  public async getSobrevivenciPresolicitud(
    request: BaseSobrevivenciaRequest
  ): Promise<AxiosResponse<SobrevivenciaPresolicitudResponse>> {
    return this.post("GetSobrevivenciaPresolicitud", request);
  }

  public async setEtapa(
    request: EtapaRequest
  ): Promise<AxiosResponse<BaseSobrevivenciaResponse>> {
    return this.post("setEtapa", request);
  }
  
  public async eliminarBeneficiario(
    request: EliminarBeneficiarioRequest
  ): Promise<AxiosResponse<BaseSobrevivenciaResponse>> {
    return this.post("EliminarBeneficiario", request);
  }

  public async getUbigeo(
    request: UbigeoRequest
  ): Promise<AxiosResponse<ServiceResponseFormulario>> {
    return this.post("GetUbigeo", request);
  }
  public async getUbigeoByCodigo(
    request: UbigeoRequest
  ): Promise<AxiosResponse<ServiceResponseFormulario>> {
    return this.post("GetUbigeoByCodigo", request);
  }

  public async firmarContratoFallecimiento(request:BaseSobrevivenciaRequest ): 
    Promise<AxiosResponse<PackageResult>> {
        return this.post('Firmar', request);
    }
    public async firmarDescargoFallecimiento(request:FirmaDescargoRequest ): 
    Promise<AxiosResponse<PackageResult>> {
        return this.post('FirmarDescargo', request);
    }
  
    public async getDistribucionBalance(
      request :BaseSobrevivenciaRequest
    ): Promise<AxiosResponse<DistribucionBalanceResponse>> {
      return this.post("DistribucionBalance",
        request
      );
    }

    public async getStorageSAS(): Promise<AxiosResponse<string>> {
      return this.post("getStorageSAS"
      ,null);
    }

    public async reenviarValidacionBiometrica(
      request :ReenvioBiometricaRequest
    ): Promise<AxiosResponse<BaseSobrevivenciaResponse>> {
      return this.post("ReenviarValidacionBiometrica",
        request
      );
    }

    public async getDeclaracionBeneficiariosDoc(
      numPreSolicitud :number
    ): Promise<AxiosResponse<string>> {
      return this.post("GetDeclaracionBeneficiariosLink/"+numPreSolicitud,
      null
      );
    }
}
